var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pet-icon"},[(_vm.type === 'DOG')?_c('img',{staticClass:"icon",style:({ width: _vm.iconWidth }),attrs:{"src":require("@/assets/icons/icon-dog.png")}}):(_vm.type === 'CAT')?_c('img',{staticClass:"icon",style:({ width: _vm.iconWidth }),attrs:{"src":require("@/assets/icons/icon-cat.png")}}):_c('div',[_vm._v(_vm._s(_vm.type))])])
}
var staticRenderFns = []

export { render, staticRenderFns }